import pb from '../api/pocketbase';

/**
 * Crée un projet dans la collection 'projects' avec les informations fournisseur et budget
 */
export async function createProject(data) {
  const email = process.env.REACT_APP_PB_ADMIN_EMAIL;
  const password = process.env.REACT_APP_PB_ADMIN_PASSWORD;

  try {
    if (!pb.authStore.isValid) {
      await pb.admins.authWithPassword(email, password);
    }
  } catch (err) {
    console.error('Erreur authentification admin :', err.message);
    throw err;
  }

  try {
    // Préparer les données fournisseur et budget
    const fournisseursData = [];
    const budgetsData = [];
    
    // Extraire les informations fournisseur et budget des entries
    if (data.entries && Array.isArray(data.entries)) {
      data.entries.forEach(entry => {
        if (entry.fournisseur && entry.fournisseur.trim() !== '') {
          fournisseursData.push({
            nom: entry.fournisseur,
            rubrique: entry.rubrique || '',
            sousRubrique: entry.sousRubrique || '',
            budget: Number(entry.budgetfournisseur) || 0
          });
        }
      });
    }

    // Créer le projet avec les informations fournisseur et budget
    const projectRecord = await pb.collection('projects').create({
      nom: data.name,
      description: data.description,
      responsableChantier: data.responsableChantier,
      date: data.date || new Date().toISOString(),
      montantTotal: data.budgetTotal,
      status: data.status,
      createdBy: data.createdBy,
      rubriques: data.entries, // tableau de rubriques
      fournisseur: data.fournisseur || '', // fournisseurs concaténés
      budgetfournisseur: data.budgetfournisseur || '0', // budget total fournisseur
      fournisseursDetails: fournisseursData, // détails des fournisseurs
      budgetsDetails: budgetsData // détails des budgets
    });

    console.log("✅ Projet créé avec succès :", projectRecord);
    console.log("📋 Fournisseurs détaillés :", fournisseursData);
    console.log("💰 Budgets détaillés :", budgetsData);

    return {
      project: projectRecord,
      fournisseurs: fournisseursData,
      budgets: budgetsData
    };

  } catch (err) {
    console.error("❌ Erreur enregistrement projet :", err.message);
    throw err;
  }
}

export async function updateProject(id, updates) {
  try {
    const record = await pb.collection('projects').update(id, updates);
    return record;
  } catch (err) {
    console.error("Erreur update projet :", err.message);
    throw err;
  }
}

export async function deleteProject(id) {
  return { id, deleted: true };
}

export async function getProjects() {
  return await pb.collection('projects').getFullList();
}
